import CenteredScreen from '@/karehero-app/onboarding/current-flow/CenteredScreen';
import { type Account } from '@/karehero-app/access/AccountBar';

// Based on the production Access Verified screen
// (lib/llama/src/pwa/pages/AccessVerifiedV2) — shown once the work email,
// partner code or payroll ID checks out, just before the main onboarding
// questions. Copy trimmed and sentence-cased for the redesigned flow.
const AccessVerifiedScreen = ({
  onContinue,
  account,
  description = "Your access is confirmed. Next we'll ask a few quick questions to set up your account and shape the right support for you. It takes about a minute.",
}: {
  onContinue: () => void;
  /** The body under the heading. Onboarding 1.1 says what they get instead. */
  description?: string;
  /** The app bar. See StepScreen's own `account`. */
  account?: Account;
}) => (
  <CenteredScreen
    account={account}
    title="You're in"
    description={description}
    actions={[
      {
        label: 'Continue',
        variant: 'primary',
        onClick: onContinue,
      },
    ]}
  />
);

export default AccessVerifiedScreen;
